module.exports = __webpack_public_path__ + "img/LV2.ef526a23.webp";